import { TableColumn } from '@/classes'

const Columns = [
  new TableColumn('Make', 'MAKE', true, 'asc', 'left'),
  new TableColumn('Model', 'MODEL', true, 'asc', 'left'),
  new TableColumn('Cylinders', 'CYLINDERS', true, 'asc', 'left'),
  new TableColumn('Bodies', 'BODIES', true, 'asc', 'left'),
  new TableColumn('Active', 'ACTIVE', true, 'asc', 'centered'),
  new TableColumn('', 'action', false, 'desc', 'centered')
]

export { Columns }
